let CryptoJS = require("crypto-js");

export const aesDecrypt = (data)=> {
    try{
        let secret_key = process.env.REACT_APP_DECRYPT_KEY
        let keys = CryptoJS.enc.Utf8.parse(secret_key);
        let base64 = CryptoJS.enc.Base64.parse(data);
        let src = CryptoJS.enc.Base64.stringify(base64);
        let decrypt = CryptoJS.AES.decrypt(src, keys, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
        return decrypt?.toString(CryptoJS.enc.Utf8);
    }catch(err){
        console.log(`Error in aesDecrypt function>>`, err);
    }
};